// extracted by mini-css-extract-plugin
module.exports = {"c-nav":"nav_c-nav__u6tkp","c-nav-item":"nav_c-nav-item__fMtt6","-is-active":"nav_-is-active__O13_G","-format-vertical":"nav_-format-vertical__punif"};